<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/authentication/user.store'
import OnDemandTrainingErrorDialog from '@/components/OnDemandTrainingErrorDialog.vue'
import { useOnDemandTrainingLogin } from '@/components/useOnDemandTrainingLogin'
import { toolkitUrls } from '@/util/links'
import { FROM_HOME, HOME_EVENT_NAMES } from './event_names'
import { TRAINING_CENTER_HEADING_CLASSES, TRAINING_CENTER_LINK_CLASSES } from './training_center_styles'

const { showTrainingButton } = storeToRefs(useUserStore())
const { hasLoginFailed, openOnDemandTraining } = useOnDemandTrainingLogin({
  eventName: HOME_EVENT_NAMES.CLICKED_ON_DEMAND_TRAINING,
  eventData: FROM_HOME
})
</script>

<template>
  <div>
    <h2 class="mb-[10px] ml-4 mt-5 text-[1rem] font-medium uppercase leading-[1.1]">Training Center</h2>
    <section>
      <div
        v-if="showTrainingButton"
        class="mb-4 border border-[#BDBDBD] bg-gray-100 px-4 pb-4 max-[480px]:border-0 max-[480px]:bg-transparent"
        data-testid="on-demand-training"
      >
        <h3 :class="TRAINING_CENTER_HEADING_CLASSES" class="mt-5">On-Demand Training</h3>
        <p class="mb-[10px]">Access a series of self-paced training courses for Goalbook Toolkit.</p>
        <a href="#" :class="TRAINING_CENTER_LINK_CLASSES" class="cursor-pointer" @click.prevent="openOnDemandTraining">Launch On-Demand Training</a>
      </div>
    </section>
    <OnDemandTrainingErrorDialog v-model:visible="hasLoginFailed" :webinars-url="toolkitUrls.webinars" />
  </div>
</template>
